import { render, staticRenderFns } from "./ReportNumberplate.vue?vue&type=template&id=4a80b53c&scoped=true&"
import script from "./ReportNumberplate.vue?vue&type=script&lang=ts&"
export * from "./ReportNumberplate.vue?vue&type=script&lang=ts&"
import style0 from "./ReportNumberplate.vue?vue&type=style&index=0&id=4a80b53c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80b53c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
